module.exports = "pegasus/assets/hexline-facebook.png";